<div class="xzoom-container">
  <div class="img-container" (click)="openFancyBox($event.target, $event)">
    <img [src]="images.length ? images[activeImg].url : defaultImage" class="xzoom" id="xzoom-default" [attr.xoriginal]="images.length ? images[activeImg].url : defaultImage" [alt]="product.title"/>
  </div>
  <div class="xzoom-thumbs">
    <a role="button" *ngFor="let image of images; let i = index;" (click)="changeActiveImage(i)">
      <div class="img-thumb">
        <img [src]="image.url" class="xzoom-gallery" width="50" [alt]="product.title" [attr.xoriginal]="image.url"/>
      </div>
    </a>
  </div>
</div>
